import classNames from 'classnames';
import { useState } from 'react';
import parse from 'html-react-parser';
import { Button, Divider, Form, Input, Space } from 'antd';
import ConsentSequent from './ConsentSequent';
import { useTranslation } from 'react-i18next';
import 'moment/locale/th';
import { toBuddhistYear } from '../../../../../util/util';
import moment from 'moment';

const Preview = (props) => {
    const {
        edit,
        editObject,
        image,
        values,
        form,
        setPublished,
        loading,
        setOpenConfirm,
        loadingSaveDraft,
        setLoadingSaveDraft,
        notes,
        combinedDragData,
        setCombinedDragData,
        state,
    } = props;

    const { t } = useTranslation('consent');
    const [lang, setLang] = useState('th');

    const templateDesignIdentity =
        Form.useWatch('templateDesignIdentity', form) ?? [];

    const isRequireOtp = Form.useWatch('isRequireOtp', form);

    return (
        <>
            <div className="bg-white p-4 py-6 rounded-lg flex items-center justify-between mb-4">
                <div className="flex items-center space-x-4">
                    <div className="text-2xl font-semibold">
                        {edit
                            ? t('Edit Template Design')
                            : t('Add Template Design')}
                        {editObject?.latestPublishedDate && (
                            <p className="text-xs text-[#65707A] font-normal mb-0">
                                {t('Last published')} :{' '}
                                {editObject?.latestPublishedDate}
                            </p>
                        )}
                    </div>
                    <div
                        style={{
                            border:
                                editObject?.status === 'Published'
                                    ? '1px solid #4ACE8F'
                                    : '1px solid #9A9A9A',
                        }}
                        className={classNames(
                            'text-xs text-[#9A9A9A] rounded-xl w-max px-2 flex-shrink-0',
                            {
                                '!text-[#4ACE8F]':
                                    editObject?.status === 'Published',
                            }
                        )}
                    >
                        {editObject?.status ?? 'Draft'}{' '}
                        {editObject?.version ?? '0000.0'}
                    </div>
                </div>
                {state?.SW?.state?.activeStep === 4 && (
                    <div className="space-x-4">
                        <Button
                            loading={loadingSaveDraft}
                            onClick={() => {
                                setLoadingSaveDraft(true);
                            }}
                            className="!border-purple !text-purple px-10"
                            htmlType="submit"
                            size="large"
                        >
                            {t('Save')}
                        </Button>
                        <Button
                            loading={loading}
                            onClick={() => {
                                setOpenConfirm(true);
                                setPublished(true);
                            }}
                            size="large"
                            type="primary"
                        >
                            {t('SavePublish')}
                        </Button>
                    </div>
                )}
            </div>

            <div className="bg-white p-4 py-6 rounded-lg">
                <div className="flex items-center justify-between">
                    <div className="text-tiny flex space-x-4">
                        <button
                            type="button"
                            className={classNames('cursor-pointer', {
                                'text-purple font-semibold': lang === 'th',
                            })}
                            onClick={() => setLang('th')}
                        >
                            {t('Thai')}
                        </button>
                        <svg
                            width="1"
                            height="21"
                            viewBox="0 0 1 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <line
                                x1="0.5"
                                y1="2.18557e-08"
                                x2="0.499999"
                                y2="21"
                                stroke="#65707A"
                            />
                        </svg>
                        <button
                            type="button"
                            className={classNames('cursor-pointer', {
                                'text-purple font-semibold': lang === 'en',
                            })}
                            onClick={() => setLang('en')}
                        >
                            {t('English')}
                        </button>
                    </div>
                    {editObject?.updateBy && (
                        <div className="flex items-center text-sm font-semibold space-x-2">
                            <span> {t('Last updated')} :</span>
                            <span className="font-medium">
                                {editObject?.updateBy}, {editObject?.updateDate}
                            </span>
                        </div>
                    )}
                </div>
                <div
                    style={{ border: '1px solid #ECECEC' }}
                    className="rounded-lg p-4 py-6 mt-6 space-y-4 text-sm"
                >
                    {image && (
                        <center>
                            <img
                                className="object-cover rounded"
                                src={image}
                                height={70}
                                alt={values?.titleEn}
                            />
                        </center>
                    )}
                    <div className="text-center text-xl font-semibold">
                        {lang === 'th'
                            ? parse(`${values?.titleTh}`)
                            : parse(`${values?.titleEn}`)}
                    </div>
                    <Divider />
                    <div className="font-semibold">
                        {lang === 'th'
                            ? parse(`${values.templateNameTh}`)
                            : parse(`${values.templateNameEn}`)}
                    </div>
                    <Form name="new">
                        {templateDesignIdentity?.map((item, index) => {
                            return (
                                <Form.Item
                                    name={['new_item', index]}
                                    className="w-full"
                                    key={index}
                                    label={
                                        lang === 'th'
                                            ? item?.labelNameTh
                                            : item?.labelNameEn
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: t('RequiredField'),
                                        },
                                    ]}
                                >
                                    <Input
                                        size="large"
                                        maxLength={50}
                                        showCount
                                    />
                                </Form.Item>
                            );
                        })}
                    </Form>
                    <div>
                        {lang === 'th'
                            ? parse(`${values.firstParagraphTh}`)
                            : parse(`${values.firstParagraphEn}`)}
                    </div>
                    {/* DND */}
                    <ConsentSequent
                        lang={lang}
                        form={form}
                        notes={notes}
                        combinedDragData={combinedDragData}
                        setCombinedDragData={setCombinedDragData}
                    />
                    <div>
                        {lang === 'th'
                            ? parse(`${values.certificationTh}`)
                            : parse(`${values.certificationEn}`)}
                    </div>

                    {lang === 'th'
                        ? values?.contactChannelTh && (
                              <>
                                  <div className="font-semibold">
                                      ช่องทางการติดต่อ
                                  </div>
                                  <div>
                                      {parse(`${values.contactChannelTh}`)}
                                  </div>
                              </>
                          )
                        : values?.contactChannelEn && (
                              <>
                                  <div className="font-semibold">
                                      Contact channel
                                  </div>
                                  <div>
                                      {parse(`${values.contactChannelEn}`)}
                                  </div>
                              </>
                          )}

                    <div>
                        {lang === 'th'
                            ? `เอกสารฉบับนี้ปรับปรุงล่าสุดเมื่อ ${toBuddhistYear(
                                  moment(values.effectiveDate).locale('th'),
                                  'LL'
                              )}`
                            : `This document was last updated on ${moment(
                                  values.effectiveDate
                              )
                                  .locale('en')
                                  .format('LL')}`}
                    </div>
                    <Divider />
                    <div className="font-semibold">
                        {lang === 'th'
                            ? 'ให้ข้อมูลความยินยอม ณ วันที่ ....'
                            : 'Provide consent information as of (date) ....'}
                    </div>
                    <div
                        hidden={!isRequireOtp}
                        className="font-semibold space-y-4"
                    >
                        <div>
                            {lang === 'th'
                                ? 'กรุณาระบุอีเมลเพื่อยืนยันตัวตนด้วยรหัส OTP (One Time Password)'
                                : 'Please enter your email address to verify your identity with OTP (One Time Password)'}
                        </div>
                        <div>
                            {lang === 'th' ? 'อีเมล' : 'Email'}
                            <div>
                                <Space>
                                    <Input
                                        className="w-72"
                                        size="large"
                                        placeholder={
                                            lang === 'th'
                                                ? 'ระบุอีเมลเพื่อรับ OTP'
                                                : 'Enter your email to receive OTP.'
                                        }
                                    />
                                    <Button
                                        type="primary"
                                        size="large"
                                        className="button-link"
                                    >
                                        {lang === 'th' ? 'รับรหัส' : 'Get OTP'}
                                    </Button>
                                </Space>
                            </div>
                        </div>
                        <div>
                            {lang === 'th'
                                ? 'ป้อนรหัส OTP (รหัสอ้างอิง: XXXXXX)'
                                : 'Enter OTP code (Reference code: XXXXXX)'}
                            <div>
                                <Space>
                                    <Input
                                        className="w-72"
                                        disabled
                                        size="large"
                                    />
                                    <Button
                                        disabled
                                        type="primary"
                                        size="large"
                                        className="button-link"
                                    >
                                        {lang === 'th'
                                            ? 'ยืนยัน OTP'
                                            : 'Confirm OTP'}
                                    </Button>
                                </Space>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Preview;
